<template>
  <div class="billing-country-confirmation" v-if="company.currency_locked !== true">
    <div v-if="countryList" class="billing-country-confirmation__dialog">
      <VLoadingSpinner v-if="loading" />
      <VMessage type="warning" subtype="outlined" :fullwidth="true">
        <template v-slot:icon>
          <ExclamationTriangleIcon />
        </template>
        <template v-slot:text>
          {{ $t('companySettings.billing.confirmCountry.chooseCarefullyMessage') }}
        </template>
      </VMessage>
      <div class="billing-country-confirmation__dialog__content">
        <VImage
          class="billing-country-confirmation__flag"
          :src="require(`@/assets/flags/${countryCode}.svg`)"
          :error="require('@/assets/loading.png')"
          :key="`flag-${countryCode}`"
        />
        <p v-if="showSelector === false">{{ $t('companySettings.billing.confirmCountry.confirmYourCountryIs') }} <b>{{ selectedCountryName }}</b></p>
        <p v-else>{{ $t('companySettings.billing.confirmCountry.selectYourCountry') }}</p>
        <ElSelect v-if="showSelector" size="large" v-model="countryCode" class="billing-country-confirmation__dialog__content__select">
          <ElOption
            v-for="country in countryList"
            data-ec="country_confirmation"
            :data-et="`select_country_${country.name}`"
            :key="country.code"
            :value="country.code"
            :label="country.name"
          />
        </ElSelect>
        <p>{{ $t('companySettings.billing.confirmCountry.billedIn') }} <b>{{ selectedCountryCurrency }}</b></p>
        <VButton
          type="cta-1"
          @click="setCountry"
          data-test="button-new-envelope"
          data-ec="country_confirmation"
          data-et="confirm_button">
          <span>{{ $t('functional.confirm') }}</span>
        </VButton>

        <p class="billing-country-confirmation__dialog__content__select-different-country" v-if="!showSelector">
          <a href="#" @click="showSelector = true;">{{ $t('companySettings.billing.confirmCountry.selectDifferentCountry') }}</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import VLoadingSpinner from '@/components/deprecated/atoms/LoadingSpinner.vue';
import VButton from '@/components/deprecated/atoms/Button.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VImage from '@/components/atoms/Image.vue';
import { mapGetters } from 'vuex';
import { ExclamationTriangleIcon } from '@/components/icons/fontIcons';

export default {
  name: 'BillingCountryConfirmation',
  components: {
    VButton,
    VLoadingSpinner,
    VMessage,
    VImage,
    ExclamationTriangleIcon,
  },
  data() {
    return {
      showSelector: false,
      countryCode: 'GB',
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      company: 'company/company',
      countryList: 'countries/countries',
    }),
    selectedCountryName() {
      if (!this.countryList) return '-';
      const selectedCountry = this.countryList.find(country => country.code === this.countryCode);
      if (selectedCountry.code === 'GB') return 'United Kingdom'; // Our country has a very long name, don't look at me like that
      return selectedCountry.name;
    },
    selectedCountryCurrency() {
      if (!this.countryList) return '-';
      const selectedCountry = this.countryList.find(country => country.code === this.countryCode);
      return `${selectedCountry.default_currency.name} (${selectedCountry.default_currency.code})`;
    },
  },
  mounted() {
    this.countryCode = this.company.country_code;
    this.$store.dispatch('countries/GET').then(() => {
      this.loading = false;
    });
  },
  methods: {
    setCountry() {
      this.loading = true;
      this.$store.dispatch('company/UPDATE', {
        country_code: this.countryCode,
        lock_country: true,
      }).then(() => {
        this.$emit('fetchBilling'); // TODO there's probably a better way to do this
        this.loading = false;
      }).catch(() => {
        this.$store.dispatch('company/GET');
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
.billing-country-confirmation {
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  width: calc(100% + 30px);
  height: calc(100% + 30px);
  z-index: 2;
  top: calc(0px - var(--spacing-base));
  left: calc(0px - var(--spacing-base));
}

.billing-country-confirmation__dialog {
  position: absolute;
  max-width: calc(600px - 20px);
  min-height: 300px;
  width: 100%;
  background: white;
  border-radius: 9px;
  top: 150px;
  left: 50%;
  transform: translateX(-50%);
  padding: var(--spacing-base);
  box-shadow: 0 0 20px 0 rgba(34, 34, 34, 0.2);
}

.billing-country-confirmation__dialog__content {
  text-align: center;
}

.billing-country-confirmation__dialog__content .a-button {
  float: none;
  display: block;
  width: auto;
  max-width: fit-content;
  margin: 0 auto;
}

.billing-country-confirmation__dialog__content__select {
  margin-bottom: var(--spacing-base);
  width: 100%;
}

.billing-country-confirmation__dialog__content__select-different-country {
  font-size: 12px;
  margin-top: 10px;
}

.billing-country-confirmation__flag {
  margin: 15px auto;
  max-height: 80px;
  border-radius: 9px;
  width: auto;
  box-shadow: 0px 0px 4px -2px black;
}
</style>
